/*
 * Cookie Preferences footer link (cloud.b, CloudiKids, Petit Artichaut).
 * The footer menu item "Cookie Preferences" has the URL "#" (the market prefix makes it "/en-us#").
 *  - Click: opens Shopify's cookie preferences panel, window.privacyBanner.showPreferences().
 *  - Visibility: hidden where no banner applies. Shopify's Customer Privacy API answers
 *    shouldShowBanner() and saleOfDataRegion(); both false hides the link, unless the visitor has already
 *    answered the banner (shouldShowBanner() is false once consent is set, and a visitor who consented must
 *    still be able to withdraw it). If the API does not load, the link stays: a failure never removes the way out.
 * Links are found by what they are (a footer link whose href ends in "#"), not by their position in the menu.
 */
(function () {
  'use strict';

  var LINKS = 'a.small-nav__link, a.footer-nav__link, a.rd-footer__policy-link';
  var KINDS = ['marketing', 'analytics', 'preferences', 'sale_of_data'];

  function cookieLinks() {
    return Array.prototype.filter.call(document.querySelectorAll(LINKS), function (a) {
      var href = a.getAttribute('href') || '';
      return href.charAt(href.length - 1) === '#';
    });
  }

  function open(event) {
    event.preventDefault();
    event.stopPropagation();
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') { banner.showPreferences(); return; }
    var legacy = document.querySelector('#shopify-pc__banner');   // the banner itself, where the panel method is absent
    if (legacy) legacy.style.display = 'block';
  }

  function applies(api) {
    if (api.shouldShowBanner() || api.saleOfDataRegion()) return true;
    var seen = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() || {} : {};
    return KINDS.some(function (k) { return seen[k] === 'yes' || seen[k] === 'no'; });
  }

  function hide(link) {
    var item = link.closest('li') || link;
    item.hidden = true;
    item.style.display = 'none';
    // Petit Artichaut prints a "|" inside each item but the last: the item before keeps a stray one
    var before = item.previousElementSibling, bar = before && before.querySelector('span');
    if (bar && bar.textContent.trim() === '|') bar.style.display = 'none';
  }

  function init() {
    var links = cookieLinks();
    if (!links.length) return;
    links.forEach(function (a) { a.addEventListener('click', open); });

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
      var api = window.Shopify.customerPrivacy;
      if (error || !api || typeof api.shouldShowBanner !== 'function' || typeof api.saleOfDataRegion !== 'function') return;
      if (!applies(api)) links.forEach(hide);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
